module.exports = __webpack_public_path__ + "static/3i-8e90b967ea69fc68b130d36cc34d41c0.woff";